<div class="page"
     [ngClass]="wallpaperUrl ? 'wallpaper-image' : 'wallpaper-color'"
     [ngStyle]="{'background-image': wallpaperUrl ? 'url(' + wallpaperUrl + ')' : null}">
    <!-- Logo -->
    <div 
        [style.background-image]="logoUrl()"
        class="logo" 
    >
    </div>

    <!-- Buttons -->
    <div class="btn-container">
        <button class="btn" (click)="displayMenu()">
            {{ 'MENU.MENU' | translate | uppercase}}
        </button>

        @if (isCallWaiterEnabled) {
            @for (option of waiterOptions(); track option.id) {
                <button class="btn" 
                    (click)="callWaiter(option.id)" 
                    [class.disabled]="(waiterOptionCountdowns.get(option.id) ?? 0) > 0">
                    {{option.name | uppercase}}
                    @if ((waiterOptionCountdowns.get(option.id) ?? 0) > 0) {
                        <div class="seconds">
                            <span>
                                {{ waiterOptionCountdowns.get(option.id) ?? 0 }}
                            </span>
                        </div>
                    }
                </button>
            }
            <button class="btn" (click)="callWaiter()">
                {{ 'LANDING.CALL_WAITER' | translate | uppercase}}
            </button>
        }
        
        @if (currentRestaurant && currentRestaurant.payment_mode === payAtTableMode) {
            @if (isLoadingBill) {
                <button class="btn loader-btn">
                    <div class="loader"></div>
                    <span>{{ 'LANDING.LOADING_BILL' | translate | uppercase}}</span>
                </button>
            } @else {
                <button class="btn" (click)="displayCheckout()">
                    {{ 'LANDING.VIEW_BILL' | translate | uppercase}} {{ orderAmount | currencySpace }}
                </button>
            }
        }

        @if (ctaText && ctaUrl) {
            <button class="btn" (click)="navigateToCTA()">
                {{ ctaText | uppercase}}
            </button>
        }

    </div>

    <!-- Promotion -->
    <app-promotion></app-promotion>
</div>